import * as yup from 'yup';
import { setMUILicenseKey } from 'libs/mui/license';

export default function bootstrap() {
  setMUILicenseKey();
  // This is where we override default validation messages
  yup.setLocale({});
}
